import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/relojchecador/incidencia-carga/';
/**
 * GET Incidencia Cargas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasCargasPag = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Incidencia Cargas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasCargas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencia Cargas
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaCarga = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Incidencia Cargas
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaCarga = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Incidencia Cargas
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaCarga = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Incidencia Cargas
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaCarga = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Incidencia Cargas
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarIncidenciaCarga = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
